/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum DomainUserRoleStringEnum {
  'UserRoleSuperManagerString' = 'super_manager',
  'UserRoleApiIntegratorString' = 'api_integrator',
  'UserRoleRecruiterString' = 'recruiter',
  'UserRoleUnknownString' = 'unknown',
}

export type DomainUserRoleString = DomainUserRoleStringEnum